import cn from 'classnames';

/**
 *  add class name
 * @param {*} param0
 */
export const addClassName = ({ existError, showError, disabled }) =>
  cn({
    exist_error_style: existError,
    show_error_style: showError,
    valid_style: !existError && !showError,
    label: !disabled,
    label_disabled: disabled,
  });
